import * as React from "react";

const HomeIcon = (props) => (
	<svg
		width={22}
		height={18}
		viewBox="0 0 22 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M1 17h2m0 0h6m-6 0V8.452c0-.534 0-.801.065-1.05a2 2 0 0 1 .28-.617c.145-.213.346-.39.748-.741l4.801-4.202C9.64 1.19 10.013.864 10.432.74c.37-.11.765-.11 1.135 0 .42.124.794.45 1.54 1.104l4.8 4.2c.402.352.603.528.748.74q.192.287.28.618c.065.249.065.516.065 1.05V17M9 17h4m-4 0v-4a2 2 0 1 1 4 0v4m0 0h6m0 0h2"
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default HomeIcon;
